export default "__VITE_ASSET__vUuabIss__"